<script lang="ts">
	import { preventDefault } from 'svelte/legacy';

	import { goto } from '$app/navigation';
	import DateInput from '$lib/DateInput.svelte';
	import InputText, { inputClasses } from '$lib/InputText.svelte';
	import LoadingButton from '$lib/LoadingButton.svelte';
	import Modal2 from '$lib/Modal2.svelte';
	import TimeInput from '$lib/TimeInput.svelte';
	import { currentEvent } from '$lib/currentEvent';
	import { routes } from '$lib/routes';
	import { format } from 'date-fns';
	import { cloneEvent } from './edit/page.telefunc';
	import { sleep } from '@melt-ui/svelte/internal/helpers';

	let open = $state(false);
	let name = $state($currentEvent.name);
	let beginDate = $state(new Date($currentEvent.beginAt ?? new Date()));
	let beginTime = $state(format(beginDate, 'HH:mm'));

	let loading = $state(false);

	async function submit() {
		loading = true;
		try {
			const { slug } = await cloneEvent($currentEvent.id, beginDate, beginTime, name);
			await sleep(600);
			await goto(routes.event(slug, true));
			open = false;
		} finally {
			loading = false;
		}
	}
</script>

<button class="btn btn-secondary" onclick={() => (open = true)}>Event Klonen</button>

<Modal2 bind:open closeButton>
	<form onsubmit={preventDefault(submit)} class="-mt-6 flex w-full flex-col gap-6">
		<div>Erstellt eine Kopie des aktuellen Events mit den gleichen Texten und Einstellungen. (Ohne Gäste)</div>

		<div class="w-full">
			<label class="label mb-2 block" for="clone-input-eventName">
				<!-- using lookalike unicode char for 'N' cuz otherwise browser autofill detection finds string 'Name' in the label and just assumes it can autofill username -->
				Νame der neuen Veranstaltung
			</label>

			<InputText
				id="clone-input-eventName"
				bind:value={name}
				required
				name="eventName"
				placeholder="z.B. Herby's kleiner Grillabend"
				autocomplete="off"
				data-testid="clone-name-input"
			/>
		</div>

		<div class="flex flex-wrap">
			<div class="mb-6 w-full md:mb-0 md:w-1/2 md:pr-8">
				<label class="label mb-2 block" for="beginDate">Datum</label>
				<DateInput
					bind:value={beginDate}
					required
					name="beginDate"
					class={`${inputClasses} w-full`}
					data-testid="clonw-begin-date-input"
				/>
			</div>
			<div class="w-full md:w-1/2">
				<label class="label mb-2 block" for="input-time">Uhrzeit</label>
				<TimeInput
					bind:value={beginTime}
					required
					name="beginTime"
					class={`${inputClasses} w-full`}
					data-testid="clone begin-time-input"
				/>
			</div>
		</div>

		<div class="flex justify-end">
			<LoadingButton {loading} class="btn btn-primary" type="submit">Event klonen</LoadingButton>
		</div>
	</form>
</Modal2>
